export const SUBMISSION_STATUS = {
  NEW_REQUEST: "New Request",
  IN_PROGRESS: "In Progress",
  CONNECTED: "Connected",
  FALLBACK: "Fallback",
  DUPLICATE: "Duplicate",
  VOID: "Void",
} as const;

export type SubmissionStatus = (typeof SUBMISSION_STATUS)[keyof typeof SUBMISSION_STATUS];

export const MATCH_STATUS = {
  SENT_TO_PROVIDER: "Sent to Provider",
  ACCEPTED: "Accepted",
  ENGAGED: "Engaged",
  CONNECTED: "Connected",
  DECLINED: "Declined",
  EXPIRED: "Expired",
  SATISFACTORY_FALLBACK: "Satisfactory Fallback",
} as const;

export type MatchStatus = (typeof MATCH_STATUS)[keyof typeof MATCH_STATUS];

export interface ProviderProfileInfo {
  clinicalSpecialties?: string[];
  modalities?: string[];
  population?: string[];
  deliveryModels?: string[];
  languagesSpoken?: string[];
  bio?: string;
  website?: string;
  openToNewClients?: boolean;
  [key: string]: unknown;
}

export interface Provider {
  id: number;
  uuid?: string;
  email: string | null;
  firstName: string;
  lastName: string;
  fullName: string | null;
  phone: string | null;
  avatar: string | null;
  avatarThumb: string | null;
  professionalCredentials: string | null;
  otherProfessionalCredentials: string | null;
  providerProfileInfo: ProviderProfileInfo | null;
  organization?: {
    id: number;
    name: string;
  } | null;
}

export interface ConnecteeMatch {
  id: number;
  providerId: number;
  connecteeSubmissionId: number;
  status: MatchStatus | string;
  metadata?: Record<string, unknown> | null;
  provider?: Provider | null;
}

export interface ConnecteeSubmission {
  id: number;
  email: string;
  status: SubmissionStatus | string;
  phone: string;
  firstName: string;
  lastName: string;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  howToContact?: string | null;
  additionalInfo?: string | null;
  providerClinicalSpecialties?: string[];
  uuid?: string;
  accessToken?: string;
  createdAt: string;
  updatedAt?: string;
  connecteeMatches?: ConnecteeMatch[];
}
